const headRowsExpiredServices = {
  date: 'fecha de vencimiento',
  equipmentEquipmentParamName: 'Equipo',
  inspection: 'Tipo de Servicio',
  questions: 'Checklist',
  placeName: 'Lugar',
};

export default headRowsExpiredServices;
